import { type CSSProperties } from 'react';

// Inline style setting CSS custom properties, e.g. `cssVariables({ '--ratio': 0.5 })`
export const cssVariables = (variables: Record<`--${string}`, string | number>): CSSProperties => variables as CSSProperties;

export const getInitials = (fullname: string): string =>
    fullname
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0].toUpperCase())
        .join('');

// Initial of the first name and capitalized last name, e.g. "Kilian JORNET BURGADA" → "K. Jornet Burgada"
export const getShortName = (fullname: string): string => {
    const [firstName, ...lastNames] = fullname.split(' ');
    const lastName = lastNames
        .join(' ')
        .toLowerCase()
        .replace(/(^|[ -])\S/g, (initial) => initial.toUpperCase());

    return lastName ? `${firstName.charAt(0)}. ${lastName}` : firstName;
};

export const toBase64 = (str: string): any => (typeof window === 'undefined' ? Buffer.from(str).toString('base64') : window.btoa(str));

export const shimmer = (w: number, h: number): string => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="#333" offset="20%" />
      <stop stop-color="#222" offset="50%" />
      <stop stop-color="#333" offset="70%" />
    </linearGradient>
  </defs>
  <rect width="${w}" height="${h}" fill="#333" />
  <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
  <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
</svg>`;
